import { useState } from 'react';
import ProductModal from '/components/layout/ProductModal';

const useProductModal = () => {
    const [isProductModalOpen, setIsProductModalOpen] = useState(false);
    const [productId, setProductId] = useState<number | undefined>();

    const openProductModal = (productId: number) => {
        setProductId(productId);
        setIsProductModalOpen(true);
    };

    const closeProductModal = () => {
        setIsProductModalOpen(false);
    };

    return {
        openProductModal,
        closeProductModal,
        productModalRender: isProductModalOpen ? (
            <ProductModal productId={productId} onClose={closeProductModal} />
        ) : null,
    };
};

export default useProductModal;
